import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requestConfig from 'app/requests/ServiceCenter/ServiceCenterMonitoring.requests'
import {
    ForecastsByProductType,
    ScenarioEditorContainerAvailability,
} from '../ScenarioEditor.types'

type RequestData = {
    serviceCenter: {
        id: number
    },
    forecastsByProduct: ForecastsByProductType[],
    includeAllDualContainers: boolean,
}

const useGetScenarioEditorContainerAvailability = (requestData: RequestData) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useRequest<ScenarioEditorContainerAvailability>({
        key: RequestKeys.scenarioEditorContainerAvailability,
        params: requestData,
        requestFunc: RequestFn.getEntity(
            requestConfig.scenarioEditorContainerAvailability,
        ),
        enabled: Boolean(
            requestData.serviceCenter
            && requestData.forecastsByProduct.length
            && requestData.forecastsByProduct,
        ),
    })

    return {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    }
}

export default useGetScenarioEditorContainerAvailability
